import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { subscribe } from '../../common/reactiveX/rxElementDecorators.js';
import { RxElement } from '../../common/reactiveX/rxElement.js';
import '../../common/loadingSpinner.js';
let FulfillmentProfile = class FulfillmentProfile extends RxElement {
    constructor() {
        super(...arguments);
        this.completeRow = '';
        this.completeActionStep = async (e) => {
            e.preventDefault();
            const id = e.target.getAttribute('data-id');
            const headers = new Headers();
            headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
            const data = {
                userId: this.userId,
                actionStepId: id,
                hubId: this.hubId,
            };
            const requestUrl = `${process.env.AIMEE_SERVICES_API_URL}/blue/actionstep/complete`;
            const results = await fetch(new Request(requestUrl, {
                method: 'POST',
                headers,
                body: JSON.stringify(data),
            }));
            if (results.ok || results.status === 200) {
                this.completeRow = null;
                this.fetchAdvisee();
            }
        };
    }
    async fetchAdvisee() {
        if (!this.hubId && !this.userId) {
            this.adviseeSummary = {
                status: 'ERRORED',
                errorMessage: 'No fulfillment ID was provided.',
            };
            return;
        }
        const requestUrl = `${process.env.API_URL}/blue/hub/${this.hubId}/user/${this.userId}/userSummary`;
        try {
            const headers = new Headers();
            headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
            const results = await fetch(new Request(requestUrl, {
                headers,
            }));
            const adviseeErrorMessage = `Error ${results.status}: ${results.statusText} was returned when requesting the resource at ${requestUrl}.`;
            if (results.ok || results.status === 200) {
                this.adviseeSummary = {
                    status: 'FOUND',
                    adviseeSummary: JSON.parse(await results.text(), (key, value) => {
                        switch (key) {
                            case 'createdDate':
                            case 'completedDate':
                                if (value) {
                                    return new Date(value);
                                }
                                return value;
                            default:
                                return value;
                        }
                    }),
                };
            }
            else if (results.status === 404) {
                this.adviseeSummary = {
                    status: 'NOT_FOUND',
                    errorMessage: adviseeErrorMessage,
                };
            }
            else {
                this.adviseeSummary = {
                    status: 'ERRORED',
                    errorMessage: adviseeErrorMessage,
                };
            }
        }
        catch (error) {
            this.adviseeSummary = {
                status: 'ERRORED',
                errorMessage: `The following error occured when requesting ${requestUrl}: ${error.name ? error.name : ''} ${error.message ? error.message : ''}`,
            };
        }
    }
    connectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.connectedCallback();
    }
    cancelCompleteActionStep(e) {
        e.preventDefault();
        this.completeRow = null;
    }
    confirmCompleteActionStep(e) {
        e.preventDefault();
        const id = e.target.getAttribute('data-id');
        this.completeRow = id;
    }
    // eslint-disable-next-line class-methods-use-this
    capitalizeWords(words) {
        const capitalized = words
            .map((word) => word[0].toUpperCase() + word.substring(1))
            .join(' ');
        return capitalized;
    }
    render() {
        switch (this.adviseeSummary.status) {
            case 'FOUND': {
                const advisee = this.adviseeSummary.adviseeSummary;
                if (!advisee) {
                    return html `<div class="tab__content">Errored</div>`;
                }
                return html `
					<div class="tab__content">
						${!advisee.isLegacyUser
                    ? html `
									${!advisee.financialWellnessScore || Number.isNaN(advisee.financialWellnessScore)
                        ? html `<table class="actionSteps">
												<thead>
													<tr>
														<th class="actionSteps__name">Aimee Score: None</th>
														<th class="actionSteps__date"></th>
														<th class="actionSteps__level"></th>
													</tr>
												</thead>
										  </table>`
                        : html `<table class="actionSteps">
												<thead>
													<tr>
														<th class="actionSteps__name">
															Aimee Score: ${advisee.financialWellnessScore}
														</th>
														<th class="actionSteps__date"></th>
														<th class="actionSteps__level"></th>
													</tr>
												</thead>
										  </table> `}
									${!advisee.incentiveModuleStatuses || !advisee.incentiveModuleStatuses.length
                        ? html `<table class="actionSteps">
												<thead>
													<tr>
														<th class="actionSteps__name">Completed Aimee Modules</th>
														<th class="actionSteps__date"></th>
														<th class="actionSteps__level"></th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td class="actionSteps__name">None</td>
														<td class="actionSteps__date"></td>
														<td class="actionSteps__level"></td>
													</tr>
												</tbody>
										  </table>`
                        : html `
												<table class="actionSteps">
													<thead>
														<tr>
															<th class="activity__name">Module Name</th>
															<th class="activity__status">Status</th>
															<th class="activity__date">Completed On</th>
														</tr>
													</thead>
													<tbody>
														${advisee.incentiveModuleStatuses.map(module => html `
																<tr>
																	<td class="activity__name">
																		${unsafeHTML(this.capitalizeWords(module.module.replace('-', ' ').split(' ')))}
																	</td>
																	<td class="activity__status">
																		${unsafeHTML(module.moduleStatus)}
																	</td>
																	<td class="activity__date">
																		${(module === null || module === void 0 ? void 0 : module.completedDate)
                            ? module.completedDate.toDateString()
                            : '-'}
																	</td>
																</tr>
															`)}
													</tbody>
												</table>
										  `}
									${!advisee.openActionSteps || !advisee.openActionSteps.length
                        ? html `<table class="actionSteps">
												<thead>
													<tr>
														<th class="actionSteps__name">Open Action Steps</th>
														<th class="actionSteps__date"></th>
														<th class="actionSteps__level"></th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td class="actionSteps__name">None</td>
														<td class="actionSteps__date"></td>
														<td class="actionSteps__level"></td>
													</tr>
												</tbody>
										  </table>`
                        : html `
												<table class="actionSteps">
													<thead>
														<tr>
															<th class="actionSteps__name">Open Action Steps</th>
															<th class="actionSteps__date">Assigned On</th>
															<th class="actionSteps__level">Level</th>
															<th class="actionSteps__action">Action</th>
														</tr>
													</thead>
													<tbody>
														${advisee.openActionSteps
                            .sort((a, b) => a.associatedMilestoneLevel - b.associatedMilestoneLevel)
                            .map(actionStep => html `<tr id="${actionStep.actionStepId}-row">
																		<td class="actionSteps__name">
																			${unsafeHTML(actionStep.actionStepDescription)}
																		</td>
																		<td class="actionSteps__date">
																			${actionStep.createdDate.toDateString()}
																		</td>
																		<td class="actionSteps__level">
																			${actionStep.associatedMilestoneLevel}
																		</td>
																		<td class="actionSteps__complete">
																			<span
																				data-id="${actionStep.actionStepId}"
																				@click="${this.confirmCompleteActionStep}"
																				@keyup="${this.confirmCompleteActionStep}"
																				class="actionSteps__action"
																				>Complete</span
																			>
																		</td>
																	</tr>
																	${this.completeRow && this.completeRow === actionStep.actionStepId
                            ? html ` <tr
																				id="${actionStep.actionStepId}-action"
																				class="actionSteps__confirm"
																		  >
																				<td class="actionSteps__confirmCell" colspan="4">
																					<p>
																						Are you sure you want to complete the Action Step
																						"${actionStep.actionStepDescription}"?
																					</p>
																					<mwc-button
																						raised
																						data-id="${actionStep.actionStepId}"
																						label="Complete"
																						style="margin:0 10px;--mdc-theme-primary:#2C7FAD;"
																						@click="${this.completeActionStep}"
																					></mwc-button>
																					<mwc-button
																						raised
																						data-id="${actionStep.actionStepId}"
																						label="Cancel"
																						style="margin:0;--mdc-theme-primary:#707070;"
																						@click="${this.cancelCompleteActionStep}"
																					></mwc-button>
																				</td>
																		  </tr>`
                            : ''} `)}
													</tbody>
												</table>
										  `}
									${!advisee.completedActionSteps || !advisee.completedActionSteps.length
                        ? html `<table class="actionSteps">
												<thead>
													<tr>
														<th class="actionSteps__name">Completed Action Steps</th>
														<th class="actionSteps__date"></th>
														<th class="actionSteps__level"></th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td class="actionSteps__name">None</td>
														<td class="actionSteps__date"></td>
														<td class="actionSteps__level"></td>
													</tr>
												</tbody>
										  </table>`
                        : html `
												<table class="actionSteps">
													<thead>
														<tr>
															<th class="actionSteps__name">Completed Action Steps</th>
															<th class="actionSteps__date">Completed On</th>
															<th class="actionSteps__level">Level</th>
														</tr>
													</thead>
													<tbody>
														${advisee.completedActionSteps
                            .sort((a, b) => a.associatedMilestoneLevel - b.associatedMilestoneLevel)
                            .map(actionStep => html `
																	<tr>
																		<td class="actionSteps__name">
																			${unsafeHTML(actionStep.actionStepDescription)}
																		</td>
																		<td class="actionSteps__date">
																			${actionStep.completedDate.toDateString()}
																		</td>
																		<td class="actionSteps__level">
																			${actionStep.associatedMilestoneLevel}
																		</td>
																	</tr>
																`)}
													</tbody>
												</table>
										  `}
									${!advisee.completedMilestones || !advisee.completedMilestones.length
                        ? html `<table class="actionSteps">
												<thead>
													<tr>
														<th class="actionSteps__name">Completed Milestones</th>
														<th class="actionSteps__date"></th>
														<th class="actionSteps__level"></th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td class="actionSteps__name">None</td>
														<td class="actionSteps__date"></td>
														<td class="actionSteps__level"></td>
													</tr>
												</tbody>
										  </table>`
                        : html `
												<table class="actionSteps">
													<thead>
														<tr>
															<th class="actionSteps__name">Completed Milestones</th>
															<th class="actionSteps__date">Completed On</th>
															<th class="actionSteps__level">Level</th>
														</tr>
													</thead>
													<tbody>
														${advisee.completedMilestones
                            .sort((a, b) => b.milestoneLevel - a.milestoneLevel)
                            .map(milestone => html `
																	<tr>
																		<td class="actionSteps__name">
																			${unsafeHTML(milestone.milestoneDescription)}
																		</td>
																		<td class="actionSteps__date">
																			${milestone.completedDate.toDateString()}
																		</td>
																		<td class="actionSteps__level">${milestone.milestoneLevel}</td>
																	</tr>
																`)}
													</tbody>
												</table>
										  `}
							  `
                    : ''}
					</div>
				`;
            }
            case 'NOT_FOUND':
                return html `<div class="tab__content">Profile information could not be found</div>`;
            case 'INITIALIZING':
            case 'LOADING':
                return html `<div class="tab__content">
					<loading-spinner loadingText="Loading profile information..."></loading-spinner>
				</div>`;
            case 'ERRORED':
            default:
                return html `<div class="tab__content">Profile information failed to load.</div>`;
        }
    }
};
FulfillmentProfile.styles = css `
		:host {
			min-width: 100%;
			min-height: 100%;
		}
		.actionSteps {
			width: 100%;
			font-size: 13px;
			margin-bottom: 30px;
			border-spacing: 0px;
			border-collapse: collapse;
		}
		.tab__content {
			margin-top: 20px;
			padding: 0 20px 20px;
		}
		.actionSteps th {
			color: #073853;
			padding: 8px 20px;
			font-family: Roboto, Helvetica, Arial, sans-serif;
			font-weight: 500;
			text-transform: capitalize;
			font-size: 14px;
			background: #fff;
		}
		.actionSteps tr:nth-child(odd) {
			background: #f7f7fa;
		}
		.actionSteps td {
			padding: 8px 20px;
			font-size: 13px;
		}
		.actionSteps__date {
			width: 160px;
			text-align: center;
		}
		.actionSteps__level {
			text-align: center;
		}
		.activity__name,
		.activity__status,
		.activity__date,
		.actionSteps__name {
			text-align: left;
		}
		.actionSteps__action {
			font-weight: 500;
			color: #007cab;
			cursor: pointer;
		}
		.actionSteps__complete {
			text-align: center;
		}
		.actionSteps__confirmCell {
			text-align: right;
			background-color: #f3f9fb;
		}
		th.actionSteps__name {
			text-align: left;
		}
		th.actionSteps__date {
			text-align: center;
		}
		th.actionSteps__level {
			text-align: center;
		}
	`;
__decorate([
    property()
], FulfillmentProfile.prototype, "adviseeSummary", void 0);
__decorate([
    property()
], FulfillmentProfile.prototype, "email", void 0);
__decorate([
    property()
], FulfillmentProfile.prototype, "userId", void 0);
__decorate([
    property()
], FulfillmentProfile.prototype, "hubId", void 0);
__decorate([
    property()
], FulfillmentProfile.prototype, "fulfillmentId", void 0);
__decorate([
    property()
], FulfillmentProfile.prototype, "hub", void 0);
__decorate([
    subscribe(),
    state()
], FulfillmentProfile.prototype, "blueUser", void 0);
__decorate([
    property()
], FulfillmentProfile.prototype, "completeRow", void 0);
FulfillmentProfile = __decorate([
    customElement('fulfillment-profile')
], FulfillmentProfile);
export { FulfillmentProfile };
//# sourceMappingURL=profile.js.map